import './date-picker.scss'

import { FormApi } from 'final-form';
import { get, set, update } from 'lodash'
import moment from 'moment'
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { buildSkinDate } from '../date-helper';

@Component({
    props: ['form', 'name'],
    template: require('./date-picker.html'),
})
export class DatePicker extends ReactiveVue {

    public dateValue: string = "";
    public form: FormApi;
    public name: string;

    public mounted() {
        // Filling date picker with value
        const defaultValue = get(this.form.getState().values, this.name)
        if (defaultValue && defaultValue.startInterval.date) {
            this.dateValue = defaultValue.startInterval.date;
        } else {
            // If reportDate is blank, set today's date
            this.dateValue = moment().format("YYYY-MM-DD");
        }
    }

    /**
     * Generates a date suitable for backend data from the 
     * date-picker value
     */
    private get skinDate() {
        return buildSkinDate(this.dateValue);
    }

    private onValueChange() {
        // Modifying directly form value, converting to skin date
        set(this.form.getState().values, this.name, this.skinDate)
    }
}